import { ResolverCommandesVariables } from '../../../types/commande/commandeDefToUpdate';

export const resolverCommandeParams = (
  variables: ResolverCommandesVariables
) => {
  return {
    __typename: 'Commande',
    ...variables.commande,
    commandelines: variables.commandelines.map(commandeline => ({
      __typename: 'Commandeline',
      ...commandeline,
      produit: {
        __typename: 'Produit',
        ...commandeline.produit,
        media: {
          __typename: 'Media',
          url: commandeline?.produit?.media[0]?.url,
          ...commandeline.produit.media
        }
      }
    })),
    client: {
      __typename: 'Client',
      ...variables.client
    }
  };
};
